import { Code, Database, Globe, BotIcon } from 'lucide-react';

export const skills = [
  {
    id: 1,
    name: "Frontend",
    icon: Code,
    items: ["React", "JavaScript", "HTML/CSS", "Tailwind"]
  },
  {
    id: 2,
    name: "Backend",
    icon: Database,
    items: [ "Python", "C#","Node.js", "PostgreSQL"]
  },
  {
    id: 3,
    name: "Agentic AI",
    icon: BotIcon,
    items: ["Microsoft Foundry", "Microsoft Copilot Studio", "Azure Bot Framework", "Microsoft Agent Framework"]
  },
  {
    id: 4,
    name: "Power Platform",
    icon: Globe,
    items: ["Power Automate", "Power Apps", "Dataverse", "Power Pages"]
  }
];
